import React from 'react';

import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

import {ImportSourceType, IMPORT_SOURCE_TYPE_TO_DISPLAY_TEXT} from '../SpreadsheetBulkImportConstants';

export interface ImportSourceTypeSelectorProps {
  importSourceType: ImportSourceType;
  isSdfAllowed: boolean;
  onSelect: (importSourceType: ImportSourceType) => void;
}

export default function ImportSourceTypeSelector(props: ImportSourceTypeSelectorProps): JSX.Element {
  return (
    <SelectDropdown
      displayName={IMPORT_SOURCE_TYPE_TO_DISPLAY_TEXT[props.importSourceType]}
      menu={
        <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL}>
          {[
            ImportSourceType.SPREADSHEET,
            ImportSourceType.RAW_TEXT,
            ...(props.isSdfAllowed ? [ImportSourceType.SDF] : []),
          ].map((importSourceType) => (
            <Option
              key={importSourceType}
              value={importSourceType}
              onSelect={props.onSelect}
              dataTestAttrs={{
                component: 'ImportSourceTypeSelector',
                element: 'option',
                key: importSourceType,
              }}
            >
              {IMPORT_SOURCE_TYPE_TO_DISPLAY_TEXT[importSourceType]}
            </Option>
          ))}
        </Menu>
      }
      dataTestAttrs={{component: 'ImportSourceTypeSelector', element: 'root'}}
    />
  );
}
